import { useState } from 'react';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import styled from 'styled-components';
import { Tabs } from 'antd';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { ReactComponent as IconLogo } from 'asserts/icons/ic_Logo.svg';
import { ReactComponent as IconMetagym } from 'asserts/icons/ic_metagym.svg';
import { ReactComponent as IconSlideLeft } from 'asserts/icons/ic_chevron_left.svg';
import { ReactComponent as IconSlideRight } from 'asserts/icons/ic_chevron_right.svg';
import { ReactComponent as ImageLight } from 'asserts/images/light.svg';
import { ReactComponent as ImageWatch } from 'asserts/images/watch.svg';
import { ReactComponent as ImageGraph } from 'asserts/images/graph.svg';

import CompanyList from 'components/list/CompanyList';
import FloatingButton from 'components/button/FloatingButton';
import useScrollFadeIn from 'hooks/useScrollFadeIn';
import SliderSlick from 'components/slider/SliderSlick';
import { reportSliderData } from 'consts/main';

const Main = () => {
  const fadeInUp1 = useScrollFadeIn({ direction: 'up', duration: 2, delay: 0 });
  const fadeInUp2 = useScrollFadeIn({ direction: 'up', duration: 2, delay: 0 });
  const fadeInUp3 = useScrollFadeIn({ direction: 'up', duration: 1.5, delay: 0 });

  const bizfadeInUp = useScrollFadeIn({ direction: 'center', duration: 1.5, delay: 0.5 });

  const iconfadeInUp1 = useScrollFadeIn({ direction: 'up', duration: 1, delay: 0 });
  const iconfadeInUp1_1 = useScrollFadeIn({ direction: 'up', duration: 1, delay: 0.3 });
  const icofadeInUp2 = useScrollFadeIn({ direction: 'up', duration: 1.3, delay: 0 });
  const iconfadeInUp2_1 = useScrollFadeIn({ direction: 'up', duration: 1.3, delay: 0.3 });
  const icofadeInUp3 = useScrollFadeIn({ direction: 'up', duration: 1.6, delay: 0 });
  const iconfadeInUp3_1 = useScrollFadeIn({ direction: 'up', duration: 1.6, delay: 0.3 });

  const appfadeInUp1 = useScrollFadeIn({ direction: 'up', duration: 1.5, delay: 0.3 });
  const appfadeInUp2 = useScrollFadeIn({ direction: 'up', duration: 1.5, delay: 0 });

  const techfadeInUp1 = useScrollFadeIn({ direction: 'up', duration: 2, delay: 0 });
  const techfadeInUp2 = useScrollFadeIn({ direction: 'up', duration: 2, delay: 0.3 });

  const icon2fadeInUp1 = useScrollFadeIn({ direction: 'up', duration: 2.2, delay: 0 });
  const icon2fadeInUp2 = useScrollFadeIn({ direction: 'up', duration: 2, delay: 0.2 });
  const icon2fadeInUp3 = useScrollFadeIn({ direction: 'up', duration: 2, delay: 0.4 });
  const icon2fadeInUp4 = useScrollFadeIn({ direction: 'up', duration: 2, delay: 0.6 });

  const iconData = [
    {
      icon: <img src="/images/posture.png" alt="posture" loading="lazy" />,
      title: 'Posture',
      text: '앞·뒤·옆면 자세 검사',
      fadein: iconfadeInUp1
    },
    {
      icon: <img src="/images/manual.png" alt="manual" loading="lazy" />,
      title: 'Manual',
      text: 'Q앵글·사용자정의 검사',
      fadein: iconfadeInUp1_1
    },
    {
      icon: <img src="/images/rom.png" alt="rom" loading="lazy" />,
      title: 'ROM',
      text: '척추·관절 가동범위 검사​',
      fadein: icofadeInUp2
    },
    {
      icon: <img src="/images/moire.png" alt="moire" loading="lazy" />,
      title: 'Moire',
      text: '척추·근육 3D형상검사',
      fadein: iconfadeInUp2_1
    },
    {
      icon: <img src="/images/squat.png" alt="squat" loading="lazy" />,
      title: 'Squat',
      text: '실시간 동작 평가',
      fadein: icofadeInUp3
    },
    {
      icon: <img src="/images/golf.png" alt="golf" loading="lazy" />,
      title: 'Golf',
      text: '골프 기초체력 검사',
      fadein: iconfadeInUp3_1
    }
  ];

  const [selectedTab, setSelectedTab] = useState<
    'Posture' | 'Manual' | 'ROM' | 'Moire' | 'Movement'
  >('Posture');

  const onChangeTab = (key: string) => {
    setSelectedTab(key as 'Posture' | 'Manual' | 'ROM' | 'Moire' | 'Movement');
  };
  const listItems = [
    { title: 'Posture' },
    { title: 'Manual' },
    { title: 'ROM' },
    { title: 'Moire' },
    { title: 'Movement' }
  ];

  const sliderSetting2 = {
    dots: false,
    speed: 500,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };

  return (
    <Wrapper>
      <div className="paddingWrap">
        {/*  <VideoWrapper>
          <img className="defaultRadius" src="/images/main_video.png" alt="비디오 영역" />
          <video src="" autoPlay muted />
        </VideoWrapper>*/}
        <section>
          <h2 ref={fadeInUp1.ref} style={fadeInUp1.style}>
            엑스바디 비즈멤버십 서비스를 만나보세요
          </h2>
          <TextWrapper ref={fadeInUp2.ref} style={fadeInUp2.style}>
            <p>근골격 검사기기 시장의 절대 1위 브랜드 엑스바디를 전 세계에서 만나보세요.</p>
            <p>‘엑스바디 비즈멤버십’은 엑스바디의 새로운 메디테크 브랜드입니다.</p>
            <p>이제 온라인으로 각종 근골격질환을 검사하고 운동을 처방하세요.</p>
          </TextWrapper>
          <div ref={fadeInUp3.ref} style={fadeInUp3.style}>
            <img
              loading="lazy"
              width={440}
              height={389}
              src="/images/main_ticket.png"
              alt="티켓 이미지"
            />
          </div>
          <ImageWrapper>
            <BizImage ref={bizfadeInUp.ref} style={bizfadeInUp.style}></BizImage>
            <div>
              <IconLogo />
              <h4>Biz Membership</h4>
            </div>
          </ImageWrapper>
        </section>
        <section>
          <h2>
            자세검사부터 실시간 동작검사까지. <br /> 다양한 근골격 검사서비스
          </h2>
          <Service>
            <LeftImg>
              <img loading="lazy" src="/images/main_skeleton.png" alt="스켈레톤 이미지" />
            </LeftImg>
            <div>
              {iconData.map((data) => {
                const { icon, title, text, fadein } = data;
                return (
                  <Icon key={title} ref={fadein.ref} style={fadein.style}>
                    {icon}
                    <div>
                      <h6>{title}</h6>
                      <p>{text}</p>
                    </div>
                  </Icon>
                );
              })}
            </div>
          </Service>
        </section>
        <SlideSection>
          <h2>
            수십년의 노하우를 담은
            <br />
            엑스바디의 검사결과 리포트
          </h2>
          <SliderArea>
            <Tabs
              defaultActiveKey="Posture"
              centered
              items={listItems.map((item) => {
                return {
                  label: item.title,
                  key: item.title
                };
              })}
              onChange={onChangeTab}
            />
            <SliderSlick images={reportSliderData[selectedTab]} />
          </SliderArea>
        </SlideSection>
      </div>
      <MetagymSection>
        <IconMetagym />
        <p>METAGYM을 활용한 맞춤형 운동 제작, PT, GX</p>
        <MetagymImageWrapper>
          <SlideWrapper>
            <Slider {...sliderSetting2}>
              {new Array(8).fill('').map((data, index) => (
                <div key={index}>
                  <img loading="lazy" src={`images/metagym${index}_box.png`} alt="metagym" />
                </div>
              ))}
            </Slider>
          </SlideWrapper>
          <img loading="lazy" className="tools" src="images/tools.png" alt="tools" />
        </MetagymImageWrapper>
        <HeaderWrapper>
          <h2>
            회원 개인을 위한 엑스바디
            <br />
            Mobile Application
          </h2>
          <p>
            체형분석 결과 리포트와 맞춤형 운동 영상까지!
            <br />
            엑스바디 앱 하나로 편하게 확인하고 스마트하게 관리하세요.
          </p>
        </HeaderWrapper>
        <AppImageWrapper>
          <div ref={appfadeInUp1.ref} style={appfadeInUp1.style}>
            <img loading="lazy" src="images/app_left.png" alt="exbody app" />
          </div>
          <div ref={appfadeInUp2.ref} style={appfadeInUp2.style}>
            <img loading="lazy" src="images/app_right.png" alt="exbody app" />
          </div>
        </AppImageWrapper>
      </MetagymSection>
      <div className="paddingWrap">
        <TechSection>
          <div ref={techfadeInUp1.ref} style={techfadeInUp1.style}>
            <h2>
              First Innovation
              <br />
              Technology
            </h2>
            <p>대한민국 최초 공인된 혁신 국가대표 기술력</p>
          </div>
          <p ref={techfadeInUp2.ref} style={techfadeInUp2.style}>
            <img loading="lazy" src="images/people.png" alt="people" className="defaultRadius" />
          </p>
        </TechSection>
        <IconSection>
          <h2 ref={icon2fadeInUp1.ref} style={icon2fadeInUp1.style}>
            엑스바디 비즈멤버십은 3가지를 고민했습니다.
          </h2>
          <IconWrapper>
            <div ref={icon2fadeInUp2.ref} style={icon2fadeInUp2.style}>
              <ImageLight />
              <p>
                사용자들에게 ‘정말로’
                <br />
                필요한 정보를 제공할 것
              </p>
            </div>
            <div ref={icon2fadeInUp3.ref} style={icon2fadeInUp3.style}>
              <ImageWatch />
              <p>
                운영자들의 업무 부담을
                <br />
                ‘반드시’ 줄여줄 것
              </p>
            </div>
            <div ref={icon2fadeInUp4.ref} style={icon2fadeInUp4.style}>
              <ImageGraph />
              <p>
                도입 예산은 ‘최소화’하고
                <br />
                성과는 ‘분명하게’ 보여 줄 것
              </p>
            </div>
          </IconWrapper>
        </IconSection>
        <PartnerSection>
          <h2>
            많은 파트너들이
            <br />
            엑스바디와 함께 하고 있습니다.
          </h2>
          <CompanyList />
        </PartnerSection>
      </div>
      <FloatingWrapper>
        <FloatingButton />
      </FloatingWrapper>
    </Wrapper>
  );
};

export default Main;

const PrevArrow = (props: any) => {
  const { onClick, className, style } = props;
  return (
    <div className={className} style={{ ...style, zIndex: 1 }} onClick={onClick}>
      <IconSlideLeft fill="#fff" />
    </div>
  );
};

const NextArrow = (props: any) => {
  const { onClick, className, style } = props;
  return (
    <div className={className} style={{ ...style, zIndex: 1 }} onClick={onClick}>
      <IconSlideRight fill="#fff" />
    </div>
  );
};

const Wrapper = styled.div`
  // position: relative;
  // width: 1440px;
  margin: 0 auto;
  text-align: center;
  color: ${color.black2};
  // max-width:calc(100% - 96px);
  padding: 128px 0 48px;
  div.paddingWrap {
    padding-top: 24px;
  }

  p {
    color: ${color.gray600};
    text-align: center;
    font-size: 20px;
    line-height: 24px;
  }

  h2 {
    color: ${color.navyLight};
    text-align: center;
    ${font.d1_bold}
  }

  img.defaultRadius {
    border-radius: 24px;
  }

  section {
    margin-bottom: 128px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0;
  p {
    ${font.h3_Regular};
    color: ${color.gray600};
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  max-width: 1440px;
  height: 360px;
  margin: 72px auto 0;
  border-radius: 24px;
  overflow:hidden;
  padding:0 48px;
  h4 {
    padding-top:12px;
    color: ${color.white};
    text-shadow: 0px 2px 4px ${color.opacityBlack02});
    ${font.d1_bold};
  }

  div {
    position: absolute;
    top: 103px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const BizImage = styled.p`
  background-blend-mode: multiply;
  // background-image: url('/images/membership.png');
  // background-size: cover;
  width: 100%;
  height: 100%;
  border-radius: 24px;
  overflow: hidden;
  background: url('/images/membership.png') lightgray 50% / cover no-repeat;
  mix-blend-mode: multiply;
`;

const Service = styled.div`
  display: flex;
  justify-content: center;
  gap: 21px;
  padding-top: 128px;
  & > div {
    display: flex;
    flex-wrap: wrap;
    width: 434px;
    gap: 24px 8px;
  }
`;

const LeftImg = styled.p`
  width: 434px;
  height: 756px;
  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
  }
`;

const Icon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 212px;

  h6 {
    ${font.h3_bold};
    padding-bottom: 8px;
  }

  p {
    color: ${color.black2};
    text-align: center;
    ${font.body_regular};
  }
  img {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
  }
  &:hover {
    img {
      transform: scale(1.1);
      box-shadow: 0px 0px 19px 1px rgba(0, 0, 0, 0.2);
    }
  }
`;

const SlideSection = styled.section`
  h2 {
    margin-bottom: 64px;
  }
`;

const SliderArea = styled.div`
  h4 {
    ${font.h2_bold};
    margin-bottom: 64px;
  }
  .ant-tabs {
    width: max-content;
    margin: 64px auto;
    .ant-tabs-tab-btn {
      ${font.h2_medium};
    }
  }

  p {
    margin: 48px 0 0;
    color: ${color.black2};
    ${font.h2_bold};
  }
`;

const MetagymSection = styled.section`
  padding-top: 200px;
  background: linear-gradient(180deg, #05054c 0%, rgba(5, 5, 76, 0) 100%);
  height: 1800px;
  margin-bottom: 803px !important;

  p {
    padding: 32px 0 80px;
    color: ${color.white};
    text-shadow: 0px 2px 4px ${color.opacityBlack02};
    ${font.h2_regular};
  }
`;

const MetagymImageWrapper = styled.div`
  position: relative;

  & img.tools {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -345px;
  }

  & > div {
    margin-bottom: 481px;
  }
`;

const SlideWrapper = styled.div`
  width: 890px;
  height: 520px;
  margin: 0 auto;

  /* 🔽 추가! */
  .slick-prev::before,
  .slick-next::before {
    content: none !important;
  }

  .imgBox {
    background-color: rgba(255, 255, 255, 0.2);
    padding: 10px;
    display: flex;
    align-items: center;
  }
  .slick-list {
    padding: 0 !important;
  }

  .slick-slide {
    border-radius: 8px;
    img {
      border-radius: 8px;
      width: 890px;
      height: 520px;
    }
  }

  & .slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 54px;
    height: 54px;
    padding: 14px;
    border-radius: 32px;
    border: 1px solid ${color.white};

    &.slick-disabled {
      opacity: 0.1;
      cursor: default;
    }

    & svg {
      width: 24px;
      height: 24px;
    }
  }

  & .slick-prev {
    left: -102px;
  }

  & .slick-next {
    right: -102px;
  }
`;

const HeaderWrapper = styled.div`
  p {
    color: ${color.gray600};
    text-shadow: none;
  }
`;

const AppImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;

  div:first-of-type {
    padding: 128px 0 0 0;
  }

  div {
    padding: 0 0 128px 0;
  }

  img {
    width: 380px;
  }
`;

const TechSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;
    width: 435px;

    h2 {
      text-align: left;
    }
  }

  img {
    width: 435px;
  }
`;

const IconSection = styled.div`
  padding-top: 128px;

  h2 {
    padding-bottom: 72px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 85px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    width: 240px;
    height: 252px;

    p {
      ${font.h3_Regular};
    }
  }
`;

const PartnerSection = styled.section`
  h2 {
    padding: 128px 0 72px;
  }
`;

const FloatingWrapper = styled.div`
  position: fixed;
  top: 40%;
  right: 24px;

  @media (min-width: 1920px) {
    right: calc(((100% - 1920px) / 2) + 24px);
  }
`;
